import MapboxDraw from "@mapbox/mapbox-gl-draw";
import mapboxgl from "mapbox-gl";

export const SNAP_INDICATOR_SOURCE = "mu-snap-indicator";
export const SNAP_INDICATOR_LAYER = "mu-snap-indicator-layer";

const EMPTY_FC = { type: "FeatureCollection" as const, features: [] };

export const updateSnapIndicator = (
  map: mapboxgl.Map,
  sourceId: string,
  snappedLng: number,
  snappedLat: number,
  e: MapboxDraw.MapMouseEvent
): void => {
  const source = map.getSource(sourceId) as mapboxgl.GeoJSONSource | undefined;
  if (!source) return;

  const isSnapped = Math.abs(snappedLng - e.lngLat.lng) > 1e-8 || Math.abs(snappedLat - e.lngLat.lat) > 1e-8;

  if (isSnapped) {
    source.setData({
      type: "FeatureCollection",
      features: [{ type: "Feature", geometry: { type: "Point", coordinates: [snappedLng, snappedLat] }, properties: {} }],
    });
  } else {
    source.setData(EMPTY_FC);
  }
};

export const clearSnapIndicator = (map: mapboxgl.Map, sourceId: string): void => {
  const source = map.getSource(sourceId) as mapboxgl.GeoJSONSource | undefined;
  if (source) source.setData(EMPTY_FC);
};
